<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <select-extended
                v-model="inputValue"
                :clearable="clearable"
                :filter="options.length >= 8"
                autofocus-filter
                :filter-placeholder="$T('type to search')"
                :float-label="processedLabel"
                :options="options"
                :color="color"
                :disable="form.busy || disable"
                :path="path"
                :select-all="selectAll"
                :multiple="multiple"
                :chips="chips"
                :before="before"
                :after="after"
                :autofocus="autofocus"
                @input="onInput"></select-extended>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {debounce} from "quasar-framework";
    import axios from 'axios'

    export default {
        name: 'VSelectPos',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            },
            selectAll: Boolean,
            multiple: Boolean,
            chips: Boolean
        },

      mounted() {
          this.getLendingPoints()

        },

        data() {
              return {
                  inputValue: []
              }
          },

      methods:{
        getLendingPoints (){
          return axios.post('/api/v1/lending-point/lending-points-user',{ 'user': this.$route.params.id})
              .then((response) => {
                this.inputValue = response.data
                this.onInput(response.data)
              })
        },
      },

      computed: {
        hasError() {
          debounce(function () {
            if (this.form && this.path && this.form.errors) {
              return this.form.errors.has(this.path)
            }
          },400)

        },

        errorLabel() {
          debounce(function () {
            if (this.form && this.path && this.form.errors && this.form.errors.get(this.path)) {
              return this.form.errors.get(this.path)
            }
            return ''
          },400)

        }

      },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VSelectPos.vue